import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getBundle = async (id: string | undefined) => {
    const { data: bundles, error: bundlesError } = await supabase
        .from('service_bundles')
        .select(`
      *,
      service_bundle_items (
        service_id,
        services:service_id (
          *,
          service_pricing_duration (*)
        )
      )
    `)
        .eq('id', id)
        .eq('is_active', true)
        .single()

    if (bundlesError) {
        throw new Error(bundlesError.message)
    }

    return bundles
}

export default function useGetBundleById(id: string | undefined) {
    return useQuery({
        queryKey: ['bundlesBySalon', id],
        queryFn: () => getBundle(id),
        enabled: !!id
    })
}
